import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Pipe to highlight '(-)' in labels with red color
 * This indicates negative/deduction fields in financial statements
 *
 * Usage:
 * <span [innerHTML]="control.label | negativeLabel"></span>
 */
@Pipe({
  name: 'negativeLabel',
  standalone: true
})
export class NegativeLabelPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value || !value.includes('(-)')) {
      return value || '';
    }

    // Wrap '(-)' in a red span
    const transformed = value.replace(
      '(-)',
      '<span style="color: #dc2626;">(-)</span>'
    );

    return this.sanitizer.bypassSecurityTrustHtml(transformed);
  }
}
